import React from "react";
import { withRouter } from "react-router-dom";
import {
  ContainerWrapper, 
  NavStrip, 
  HrefCTA, 
  FlexLeft, 
  FlexEnd, 
  FlexSelfStart,
  HelmetTitle
 } from "../../Components/Utils";
import Layout from "../../Components/Layout";
import Navigation from "./Components/Navigation";


class Projects extends React.Component {
  constructor(props) {
    super(props);
    this.state = { 
      projects: '',
    };
  }
  
  componentDidMount() {  
    window.scrollTo(0, 0);
    return this.tikiGet();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.match.params.item !== this.props.match.params.item) {
      console.log(`DiDUpdate here with ${this.props.match.params.item}`)
      return this.tikiGet();
    }
  }

  tikiGet() {
    const url = "https://lms.ltwgers.com/globalProjectAPI.php";
    return fetch(url, {
      method: 'get',
      headers: new Headers({
        "secret": "XKLJLKJKLJLK83833dsklfj28923kncdnlkwej383843j3k",
        "itemId": this.props.match.params.item
      }),
    }).then(response => {
      return response.json();
    }).then(res => {
       this.setState({projects: res }); 
      console.log(`item ${this.props.match.params.item} is: `, res);
    }).catch(error => {
      console.error("Error occured", error);
    })
  }

  render() {        
    return (
      <div className="App">
        <HelmetTitle title={`Projects / ${this.props.match.params.item}`} />
        <Layout
          head={
            <React.Fragment>
              <Navigation />
              <NavStrip />
            </React.Fragment>
          }
          body={
            <ContainerWrapper textAlign="justify">
              {this.state.projects && 
              <div>
                <FlexLeft>
                <FlexSelfStart><h3 style={{fontWeight: "bold"}} dangerouslySetInnerHTML={{__html: this.state.projects.title}}/></FlexSelfStart>
                <FlexEnd><HrefCTA href={`https://lms.globalgers.co/item${this.state.projects.thisId}`} target="_blank" rel="noopener noreferrer" onClick={(e) => { if (!window.confirm(`You are about to open ${this.state.projects.title} in a new tab`)) { e.preventDefault(); return false; }} }>GERS Principles</HrefCTA></FlexEnd>
                </FlexLeft>
                <h4>Objectives</h4>
                  <div dangerouslySetInnerHTML={{__html: this.state.projects.description}} />
                <h4>Motivation</h4>
                  <div dangerouslySetInnerHTML={{__html: this.state.projects.motivation}}/>
              </div> 
              }
            </ContainerWrapper>
          }
        />
      </div>  
    );
  }    

}

export default withRouter(Projects)



// WEBPACK FOOTER //
// ./src/Pages/BannerItems/Projects.js